"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.find.title': 'Toggle Web Search',
    'shortcuts.find.description': 'Enable or disable web search functionality',
};
